class ProductStyles extends HTMLElement {
  constructor() {
    super();
    this.listEl = this.querySelector('.ProductStyle-swatch-list');
    if (!this.listEl) {
      this._hide();
      return;
    }

    this.parent_style = this.listEl.dataset.parentStyle;
    this.product_type = this.listEl.dataset.productType;
    this.currentId = this.listEl.dataset.currentId;

    if (this.parent_style && this.product_type) {
      this.loadStyles();
    } else {
      this._hide();
    }
  }

  _hide() {
    this.classList.add('swatch-empty--hide');
  }

  async loadStyles() {
    const url = `/search?q=${encodeURIComponent(this.product_type)}&view=${encodeURIComponent('parent-style')}&filter.v.m.custom.parent_style=${encodeURIComponent(this.parent_style)}`;
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(response.statusText);
      const html = await response.text();
      if (!html) {
        this._hide();
        return;
      }
      this.render(html);
    } catch (error) {
      console.error('[ProductStyleList]', error);
      this._hide();
    }
  }

  render(result) {
    const html = new DOMParser().parseFromString(result, 'text/html');
    const styleList = html.querySelector('.ProductStyle-result');
    if (!styleList || !styleList.querySelector('.ProductStyle-swatch-item')) {
      this._hide();
      return;
    }

    const activeItem = styleList.querySelector(`.ProductStyle-swatch-item[data-variant-id="${this.currentId}"]`);
    if (activeItem) activeItem.classList.add('active');

    this.listEl.innerHTML = styleList.innerHTML;
  }
}

customElements.define('product-style-list', ProductStyles);
